/* eslint-disable react/prop-types */
import React from 'react';
import { useIntl } from 'react-intl';
import styles from './styles';
import { makeStyles } from '@mui/styles';
import { getColumns } from './columns';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { EmptyTable } from 'components/EmptyTable';

const useStyles = makeStyles(styles);

// ==================== Componentes ======================
// Componente funcional para la barra de búsqueda rápida.
// Recibe las props y retorna la barra de búsqueda.
// Componente para la barra de búsqueda rápida en el toolbar
function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        justifyContent: 'flex-end', // Alinea el filtro a la derecha
      }}
    >
      <GridToolbarQuickFilter /> {/* Barra de búsqueda rápida para la tabla */}
    </Box>
  );
}

const AlertTable = (props) => {
  const intl = useIntl();
  const classes = useStyles();
  const { alerts } = props;
  const columns = getColumns(intl);

  return (
    <div className={classes.root}>
      <DataGrid
        // Columnas de la tabla
        columns={columns}
        // Filas con la lista de roles
        rows={alerts}
        // Deshabilitar la seleccion de filas
        rowSelection={false}
        // Configuración de tabla
        initialState={{
          ...alerts.initialState, // Estado inicial de la tabla
          pagination: {
            ...alerts.initialState?.pagination,
            paginationModel: {
              pageSize: 5, // Tamaño de la página
            },
          },
        }}
        slots={{
          toolbar: QuickSearchToolbar, // Usa el componente QuickSearchToolbar para la barra de búsqueda
          noRowsOverlay: () => <EmptyTable text="No hay Alertas por Mostrar" />, // Usa el componente CustomNoRowsOverlay para el caso de "sin datos"
        }}
        sx={{
          pt: 2,
          pb: 2,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: 'background.paper', // Color de fondo de la tabla
          border: '1px solid',
          borderColor: 'divider',
          '& .MuiDataGrid-root': {
            border: 'none', // Quitar borde de la tabla
          },
          '& .MuiDataGrid-cell': {
            borderBottom: '1px solid rgba(224, 224, 224, 1)', // Borde inferior de las celdas
            maxHeight: '60px', // Altura máxima de las celdas
          },
          '& .MuiDataGrid-columnHeaders': {
            borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior de los encabezados de columna
          },
          '& .MuiDataGrid-row': {
            borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior de las filas
            maxHeight: '60px', // Altura máxima de las filas
          },
        }}
      />
    </div>
  );
};

export default AlertTable;
